import { inject, Pipe, PipeTransform } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Pipe({
  name: 'pageCount',
  standalone: true,
})
export class PageCountPipe implements PipeTransform {
  translateService = inject(TranslateService)

  transform(numberOfPages: number): string {
    const translationKey = numberOfPages === 1 ? 'TEMPLATES.EDITOR.PAGE' : 'TEMPLATES.EDITOR.PAGES'
    return `${numberOfPages} ${this.translateService.instant(translationKey)}`
  }
}
